import { RootState } from "../../../../store";
import { QuoteCreateState } from "../types";

export const selectQuoteCreatePayload = (state: RootState): QuoteCreateState =>
  state.quoteCreate as QuoteCreateState;
